import React, { useState } from 'react';
import { Form, Select, Drawer, Typography, Input, Button, List, Row, Col } from 'antd';
import { formatDistanceToNow } from 'date-fns';
const { Text } = Typography;

const PromotionMetrices = ({ data, value, onChange, readiness, onReadinessChange, isReady, isReadyChange }) => {

  const [drawerVisible, setDrawerVisible] = useState(false);

  console.log('PromotionMetrices received props:', { readiness, isReady });

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const onCloseDrawer = () => {
    setDrawerVisible(false);
  };



  return (
    <div>
      <Row gutter={[24, 16]}>
        <Col xs={24} sm={12}>
          <Form.Item 
            label={<span style={{ fontWeight: 'bold', color: '#333' }}>Ready For Promotion<span style={{ color: '#ff4d4f', marginLeft: '4px' }}>*</span></span>}
          >
            <Select 
              value={isReady} 
              onChange={isReadyChange} 
              style={{ width: '100%' }} 
              placeholder="Select option"
              size="large"
            >
              <Select.Option value="4">Strong Yes</Select.Option>
              <Select.Option value="3">Yes</Select.Option>
              <Select.Option value="2">No</Select.Option>
              <Select.Option value="1">Strong No</Select.Option>
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item 
            label={<span style={{ fontWeight: 'bold', color: '#333' }}>Readiness<span style={{ color: '#ff4d4f', marginLeft: '4px' }}>*</span></span>}
          >
            <Select 
              value={readiness} 
              onChange={onReadinessChange} 
              style={{ width: '100%' }} 
              placeholder="Select timeframe"
              size="large"
            >
              <Select.Option value="5" title="Immediate time-frame for move, Employee ready to take on new responsibility in next 0-6 months.">
                0-6 months
              </Select.Option>
              <Select.Option value="4" title="Intermediate time-frame for move over next 7-18 months, assuming progress in current role.">
                6-18 months
              </Select.Option>
              <Select.Option value="3" title="Long-term time frame for move. May be ready in next 18-36 months.">
                18-36 months
              </Select.Option>
              <Select.Option value="2" title="Focus on growing in current role">
                36+ months
              </Select.Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>

      {/* Comments Section - Full Width */}
      <Row gutter={[0, 16]} style={{ marginTop: '16px' }}>
        <Col xs={24}>
          <Form.Item 
            label={<span style={{ fontWeight: 'bold', color: '#333' }}>Comments</span>} 
            rules={[{ required: false }]}
          >
            <Input.TextArea 
              style={{ width: '100%' }} 
              autoSize={{ minRows: 3, maxRows: 5 }} 
              placeholder="Enter your comments here..." 
              value={value} 
              onChange={onChange} 
            />
          </Form.Item>
        </Col>
        <Col xs={24} style={{ textAlign: 'center', marginTop: '-20px' }}>
          <Button 
            type="primary" 
            onClick={showDrawer}
            style={{
              borderRadius: '8px',
              height: '40px',
              fontWeight: '500',
              minWidth: '180px',
              boxShadow: '0 2px 8px rgba(24, 144, 255, 0.2)'
            }}
          >
            📋 2024 Comments from Culture Amp
          </Button>
        </Col>
      </Row>

      <Drawer
        title="Overall Comments"
        placement="right"
        width={500}
        closable={false}
        onClose={onCloseDrawer}
        visible={drawerVisible}
      >


        <List>
          <List.Item>
            <Text style={{ padding: '5px', borderRadius: '8px', fontSize: '16px', backgroundColor: '#F9E79F' }}>{data.managerNameForComment}</Text>
          </List.Item>
          <List.Item>
            <div>
              <Text style={{ fontSize: '15px', fontWeight: 'bold' }}>Functional Competencies - Comments</Text>
              <br />

              <br />
              <Text style={{ fontSize: '15px' }}>{data.funcCompComment}</Text>
            </div>
          </List.Item>
          <List.Item>
            <div>
              <Text style={{ fontSize: '15px', fontWeight: 'bold' }}>Core Competencies - Comments</Text>
              <br />
              <br />
              <Text style={{ fontSize: '15px' }}>{data.coreCompComment}</Text>
            </div>
          </List.Item>
          <List.Item>
            <div>
              <Text style={{ fontSize: '15px', fontWeight: 'bold' }}>Overall - Comments</Text>
              <br />
              <br />
              <Text style={{ fontSize: '15px' }}>{data.overallComment}</Text>
            </div>
          </List.Item>
          <List.Item>
            <div>
              <Text style={{ fontSize: '15px', fontWeight: 'bold' }}>Promotion - Comments</Text>
              <br />
              <br />
              <Text style={{ fontSize: '15px' }}>{data.promotionComment}</Text>
              <br />
            </div>
          </List.Item>
          {data.comments && (
            <List.Item>
              <div>
                <Text style={{ padding: '5px', borderRadius: '8px', fontSize: '16px', backgroundColor: '#F9E79F' }}>{data.managerName}</Text>
                <br />
                <Text type='secondary' style={{ padding: '8px', borderRadius: '8px', fontSize: '13px' }}>{formatDistanceToNow(new Date(data.commentDate), { addSuffix: true })}</Text>
                <br />
                <br />
                <Text style={{ padding: '8px', borderRadius: '8px', fontSize: '15px' }}>{data.comments}</Text>
              </div>
            </List.Item>
          )}
        </List>
      </Drawer>
    </div>

  );
};

export default PromotionMetrices;
